import $ from 'jquery';

import 'jquery-ui/ui/core';
import 'jquery-ui/ui/effect';
import 'bootstrap';
import { throttle } from 'throttle-debounce';
import { debounce } from 'throttle-debounce';

$.throttle = throttle;
$.debounce = debounce;

global.jQuery = $;
global.$ = $;
